import { IMoveHandler, MoveHandlerParams } from "./MoveHandler";
import { PieceType } from "../../../types";
import { EventType, SelectPieceEvent } from "../../../const";

export class SwingMoveHandler implements IMoveHandler {
  handleMove(params: MoveHandlerParams): void {
    // Validate this is a monkey doing a swing
    if (params.piece.type !== PieceType.Monkey) {
      throw new Error("SwingMoveHandler can only be used with Monkey pieces");
    }

    // Perform the leap movement logic without the old bonus turn side effects
    // This reuses the existing leap movement logic from MovementManager
    params.movementManager.leapMove(
      params.fromPosition,
      params.toPosition,
      params.piece,
      params.toPiece ?? null, // Pass toPiece to enable capture during swing
      params.sideEffects || [] // Use passed sideEffects for capture processing
    );

    // CRITICAL: Only grant bonus turn if the monkey survived the leap
    // If the monkey "fell" due to danger, it's no longer on the board
    const monkeyPosition = params.movementManager
      .getGameStateManager()
      .findPiecePosition(params.piece);

    if (monkeyPosition) {
      const gameState = params.movementManager.getGameStateManager().getGameState();

      // CRITICAL: Set swing return block BEFORE granting bonus turn
      // This prevents the monkey from immediately swinging back to where it came from
      params.movementManager
        .getGameStateManager()
        .setSwingReturnBlock(params.fromPosition, params.toPosition, params.piece.id);


      // Monkey survived the leap - safe to grant bonus turn
      // ALLOW CHAINING: Swing can grant a bonus turn even during an existing bonus turn
      params.movementManager
        .getGameStateManager()
        .grantBonusTurn(params.piece);

      const updatedState = params.movementManager.getGameStateManager().getGameState();


      // Auto-select the monkey for the bonus turn (preserve locked selection behavior)
      // This ensures the player can only move the monkey, preventing cheating
      setTimeout(() => {
        // CRITICAL: Use the toPosition directly since we know where the monkey moved
        // After Firebase sync, pieces get new IDs, so we can't rely on the old piece reference
        const currentGameState = params.movementManager.getGameStateManager().getGameState();

        // The monkey is at toPosition (where it just swung to)
        const square = currentGameState.board[params.toPosition.row][params.toPosition.col];
        const currentMonkey = square.Pieces.find(p => p.type === PieceType.Monkey && p.isLight === params.piece.isLight);

        if (!currentMonkey) {
          return;
        }

        // CRITICAL FIX: Update both activeBonusTurnPieceId AND lastSwingMonkeyId with the NEW piece ID after Firebase sync
        // This ensures:
        // 1. getValidMoves() will allow the monkey to move during the bonus turn
        // 2. The swing return block logic will correctly identify this monkey
        const gameState = params.movementManager.getGameStateManager().getGameState();
        gameState.activeBonusTurnPieceId = currentMonkey.id;

        // Also update the swing return block monkey ID
        if (gameState.lastSwingMonkeyId === params.piece.id) {
          gameState.lastSwingMonkeyId = currentMonkey.id;
        }

        const selectEvent: SelectPieceEvent = {
          type: EventType.selectPiece,
          pieceId: currentMonkey.id, // Use the CURRENT piece ID from the synced state
          position: params.toPosition, // Use the position where the monkey moved to
          lockSelection: true, // Lock selection to prevent moving other pieces
        };


        // Emit event through EventManager (no more direct DOM manipulation)
        params.movementManager.getEventManager().emitEvent(selectEvent);
      }, 100); // Reduced to 100ms delay to ensure the move animation completes faster
    } else {
    }
  }
}